import { Table } from "@/features/Table";
import { useBulkDeleteControls } from "@/features/Edit/useBulkDeleteControls";
import { type L1Transaction, porfolios_columns } from "./columns";
import {
  type FilterL1TransactionsSchema,
  FilterL1Transactions,
} from "./filter";

const client = "l1";
const table_name = "l1_transactions";

export const L1TransactionsTable = () => {
  const { selectionActions, modal } = useBulkDeleteControls<L1Transaction>({
    client,
    table_name,
    resourceLabel: "Transactions",
  });

  return (
    <>
      <Table<L1Transaction, FilterL1TransactionsSchema>
        label="Transactions"
        client={client}
        table_name={table_name}
        columns={porfolios_columns}
        filter={<FilterL1Transactions />}
        actions={[
          {
            label: "actions.new",
            route: `${client}/${table_name}/new`,
          },
        ]}
        enableRowSelection
        selectionActions={selectionActions}
      />
      {modal}
    </>
  );
};
